import EmbeddedFormPage from './EmbeddedFormPage';

const BillingSignUpPage = () => (
  <EmbeddedFormPage
    titleKey="Billing Sign Up"
    description="Fill out this form to sign up for Wonderschool Billing. Billing lets you collect tuition, fees, and deposits from families with automatic payments, late fees, and built-in receipts."
    formUrl="https://wonderschool.fillout.com/t/hUxsPtucKAus"
  />
);

export default BillingSignUpPage;
